import React from "react";
import PropTypes from "prop-types";
import "../../styles/ContractDetails.scss";
import PolicyInformation from "../policy-information/PolicyInformation";
import ContractHolder from "../contract-holder/ContractHolder";
import VehicleDetails from "../vehicle-details/VehicleDetails";
import LienHolder from "../lien-holder/LienHolder";
import SellingDealer from "../selling-dealer/SellingDealer";

const ContractDetails = ({ contractDetailsData, policyExpired }) => {
    const { vehicle, seller, customer, lien } = contractDetailsData;


    return (
        <React.Fragment>
            <h4 className="contract-title">Contract Details</h4>
            <PolicyInformation direction="row" policyInformationData={contractDetailsData && contractDetailsData} policyExpired={policyExpired} />
            <ContractHolder direction="row" contractHolderData={customer && customer} />
            <VehicleDetails direction="row" vehicleDetailsData={vehicle && vehicle} />
            <SellingDealer direction="column" sellingDealerData={seller && seller} />
            <LienHolder direction="column" lienHolderData={lien && lien} />
        </React.Fragment>
    )
};

ContractDetails.propTypes = {
    contractDetailsData: PropTypes.object,
    policyExpired: PropTypes.bool
}

export default ContractDetails;